import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FirebaseTourModel } from '../data-model/tour.model';
import { DatabaseService } from '../services/database.service';

@Component({
  selector: 'app-carrusel',
  templateUrl: './carrusel.component.html',
  styleUrls: ['./carrusel.component.scss']
})
export class CarruselComponent implements OnInit {
  
  carruselElements=[];

  constructor(
    private db: DatabaseService,
    private sanitizer: DomSanitizer
  ) { } 

  async ngOnInit(): Promise<void> {
    const toursQuery = await this.db.getToursLimit(9).get();
    const list=[]; //Lista de grupos de 3
    var sublist=[]; //Sublista de 3
    toursQuery.forEach(tourQuery =>{       
      var tourModel = FirebaseTourModel.objectToModel(tourQuery.data());
      if (tourModel.imageUrl) {
        tourModel.imageSanitizer = this.sanitizer.bypassSecurityTrustResourceUrl(tourModel.imageUrl);
      }else{
        tourModel.imageSanitizer = null;
      }
      sublist.push(tourModel);
      if(sublist.length==3){
        list.push(sublist);
        sublist=[];
      }
    })
    if(sublist.length!=0){
      list.push(sublist);
    }
    this.carruselElements = list;
  }

}
